import axios from "axios";
import { base_url } from "./baseUrl";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: base_url,
});

// Add a request interceptor to include the token in headers
axiosInstance.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;
    const token = user?.data?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;


const getTokenFromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

export const config = {
  headers: {
    Authorization: `Bearer ${
      getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
    }`,
    Accept: "application/json",
  },
};

// import axios from "axios";

// const getTokenFromLocalStorage = localStorage.getItem("user")
//   ? JSON.parse(localStorage.getItem("user")).data.token
//   : null;

// export const config = {
//   headers: {
//     Authorization: `Bearer ${getTokenFromLocalStorage || ""}`,
//     Accept: "application/json",
//   },
// };

// // Create an Axios instance
// const axiosInstance = axios.create();

// // Add an interceptor to include the token in non-GET requests
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("user")
//       ? JSON.parse(localStorage.getItem("user")).data.token
//       : null;

//     if (token && config.method !== "get") {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;